<div class="select-search" (click)="$event.stopPropagation()">
  <mat-icon class="select-search-icon">search</mat-icon>
  <input
    #input
    class="select-search-input"
    type="text"
    [placeholder]="placeholder"
    (input)="term = input.value"
    (keydown)="$event.stopPropagation()"
  />
  <button
    *ngIf="term"
    type="button"
    class="select-search-clear"
    (click)="clear(); $event.stopPropagation()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
